import runColors from "../createColors/runColors.js";

/**
 *
 * @param {lightTheme} lightTheme - lightTheme object
 * @param {darkTheme} darkTheme - darkTheme object
 * @param {string} paletteColorName - name of the palette color
 * @param {object} colorValue - value of the color should be object inside object
 * @returns {{light:Theme, dark:Theme}} object with light theme and dark theme
 * @description create object with light theme and dark theme for mui createTheme
 * it will setup the mode and colors automatically.
 * provide object with palette name and color.
 * in color you can provide object like text
 */
const muiAddObjObj = (lightTheme, darkTheme, paletteColorName, colorValue) => {
  if (typeof colorValue !== "object") return null;
  let colors = {};
  for (let [k, v] of Object.entries(colorValue)) {
    if (typeof v !== "string" && !Array.isArray(v)) return null;
    colors = runColors(v);
    lightTheme.palette[paletteColorName]
      ? (lightTheme.palette[paletteColorName][k] = colors.light)
      : (lightTheme.palette[paletteColorName] = { [k]: colors.light });
    darkTheme.palette[paletteColorName]
      ? (darkTheme.palette[paletteColorName][k] = colors.dark)
      : (darkTheme.palette[paletteColorName] = { [k]: colors.dark });
  }
  return true;
};

export default muiAddObjObj;
